/** Third-party libraries required by admin (from node_modules). */
import $ from './jquery-global';
import 'jquery-ui/themes/base/base.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui-timepicker-addon/dist/jquery-ui-timepicker-addon.css';
import 'pnotify/dist/pnotify.css';
import 'pnotify/dist/pnotify.buttons.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'select2/dist/css/select2.min.css';
import 'datatables.net-bs/css/dataTables.bootstrap.css';
import 'animate.css';

import 'jquery-ui/dist/jquery-ui.min';
// Single Bootstrap runtime for the whole admin shell. Expose on window so
// nais.bundle.js can use components without bundling a second copy (duplicate
// data-api handlers break collapse/accordion toggle).
import * as bootstrap from 'bootstrap';
import 'moment';
import 'datatables.net-bs';
import 'jquery-ui-timepicker-addon';
import 'nette.ajax.js';
import ClipboardJS from 'clipboard';
// Select2 CJS export is a factory — must be called with (window, jQuery) under esbuild.
// Side-effect-only `import 'select2'` does not attach $.fn.select2.
import select2Factory from 'select2';
import mousewheelFactory from 'jquery-mousewheel';
import '@fancyapps/fancybox';
import 'accessible-nprogress';
import 'floatthead';
import PNotify from 'pnotify';
import 'pnotify/dist/pnotify.buttons';

/** PNotify 3.x has no bootstrap5 skin — bridge its alert classes without legacy icon fonts. */
const pnotifyStyling = PNotify.styling as Record<string, Record<string, string>>;
if (!pnotifyStyling.bootstrap5) {
    pnotifyStyling.bootstrap5 = {
        ...pnotifyStyling.bootstrap3,
        closer: 'nais-pnotify-closer',
        notice_icon: false as unknown as string,
        info_icon: false as unknown as string,
        success_icon: false as unknown as string,
        error_icon: false as unknown as string,
    };
}

window.CKEDITOR_BASEPATH = window.CKEDITOR_BASEPATH || '/backend/js/vendor/ckeditor/';
window.bootstrap = bootstrap;
window.PNotify = PNotify;
// clipboard.js (Latte: new Clipboard(selector)) — must not clash with native window.Clipboard API
window.ClipboardJS = ClipboardJS;
window.Clipboard = ClipboardJS;

if (typeof $ !== 'function') {
    throw new Error('NAIS admin jQuery global is not initialized.');
}

window.jQuery = $;
window.$ = $;

if (typeof mousewheelFactory === 'function') {
    mousewheelFactory($);
}

if (typeof select2Factory === 'function' && !$.fn.select2) {
    select2Factory(window, $);
}

window.PNotify.prototype.options.styling = 'bootstrap5';
window.PNotify.prototype.options.width = '28rem';
window.PNotify.prototype.options.stack.spacing1 = 8;
window.PNotify.prototype.options.buttons.closer_hover = false;
